import { CompanySettingsPermissions } from '../../modules/companySettings/permissions'
import { EmployeeListPermissions } from '../../modules/employees/permissions'
import { MeetingsPagePermissions } from '../../modules/meeting/permissions'
import { PyramidsViewPermissions } from '../../modules/pyramids/permissions'
import { SidebarPermissions } from '../../routes/permissions'
import { RoleName } from '../../types'
import { Role } from './permission-helper'
import { PermissionAction } from './permissionActionEnum'

// todo: move to configuration section
// todo: crosscheck with roles set in the importer routines
export const RoleList: Array<Role> = [
  {
    name: RoleName.Replyer,
    permissions: [
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuProfile,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuOwnGrowth,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuMeetings,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuNotes,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuKudos,
      },
    ],
  },
  {
    name: RoleName.Reviewer,
    permissions: [
      {
        action: PermissionAction.ViewAlways,
        item: SidebarPermissions.sidemenuEmployees,
      },
      {
        action: PermissionAction.ViewAlways,
        item: SidebarPermissions.sidemenuMeetings,
      },
      {
        action: PermissionAction.View,
        item: MeetingsPagePermissions.reviewerMeetings,
      },
      {
        action: PermissionAction.View,
        item: MeetingsPagePermissions.subordinateMeetings,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearch,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearchResults,
      },
    ],
  },
  {
    name: RoleName.BuManager,
    permissions: [
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuEmployees,
      },
      {
        action: PermissionAction.ViewAlways,
        item: SidebarPermissions.sidemenuMeetings,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuYourCompany,
      },
      {
        action: PermissionAction.View,
        item: MeetingsPagePermissions.reviewerMeetings,
      },
      {
        action: PermissionAction.View,
        item: MeetingsPagePermissions.subordinateMeetings,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.appraisalsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.reviewerTab,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearch,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearchResults,
      },
    ],
  },
  {
    name: RoleName.CompanyManager,
    permissions: [
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuDashboard,
      },
      {
        action: PermissionAction.ViewAlways,
        item: SidebarPermissions.sidemenuMeetings,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuScoreGrids,
      },
      {
        action: PermissionAction.Hide,
        item: SidebarPermissions.sidemenuOwnGrowth,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuEmployees,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuPyramids,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuRanking,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuYourCompany,
      },
      {
        action: PermissionAction.View,
        item: MeetingsPagePermissions.reviewerMeetings,
      },
      {
        action: PermissionAction.View,
        item: MeetingsPagePermissions.subordinateMeetings,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeListRankings,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.appraisalsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.companyMeetingRequests,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.reviewerTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.targetTemplatesTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.targetReportsTab,
      },
      {
        action: PermissionAction.View,
        item: PyramidsViewPermissions.editForecast,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearch,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearchResults,
      },
    ],
  },
  {
    name: RoleName.NetworkManager,
    permissions: [
      {
        action: PermissionAction.Hide,
        item: SidebarPermissions.sidemenuOwnGrowth,
      },
      {
        action: PermissionAction.Hide,
        item: SidebarPermissions.sidemenuMeetings,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuPyramids,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuYourCompany,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeListRankings,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.employeesTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.appraisalsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.companyMeetingRequests,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.reviewerTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.targetTemplatesTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.cultivatingTalentsTab,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearch,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearchResults,
      },
    ],
  },
  {
    name: RoleName.ClusterManager,
    permissions: [
      {
        action: PermissionAction.Hide,
        item: SidebarPermissions.sidemenuOwnGrowth,
      },
      {
        action: PermissionAction.Hide,
        item: SidebarPermissions.sidemenuMeetings,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuPyramids,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuYourCompany,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeListRankings,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.employeesTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.appraisalsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.companyMeetingRequests,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.reviewerTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.targetTemplatesTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.cultivatingTalentsTab,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearch,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearchResults,
      },
    ],
  },
  {
    name: RoleName.BusinessPartner,
    permissions: [
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuDashboard,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuEmployees,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuRanking,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuPyramids,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuYourCompany,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.appraisalsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.companyMeetingRequests,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.reviewerTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.targetTemplatesTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.targetReportsTab,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearch,
      },
    ],
  },
  {
    name: RoleName.Hr,
    permissions: [
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuDashboard,
      },
      {
        action: PermissionAction.ViewAlways,
        item: SidebarPermissions.sidemenuPyramids,
      },
      {
        action: PermissionAction.Hide,
        item: SidebarPermissions.sidemenuYourCompany,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuScoreGrids,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuAllCompanies,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeListRankings,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.appraisalsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.reviewerTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.employeesTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.cultivatingTalentsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.rankingTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.pyramidsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.reviewerFullSearch,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.companyMeetingRequests,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.targetReportsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.hrFeedbackTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.hrBusinessPartnersTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.hrCountrySettingsTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.hrNationalContractReferenceTab,
      },
      {
        action: PermissionAction.View,
        item: PyramidsViewPermissions.editForecast,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.targetTemplatesTab,
      },
      {
        action: PermissionAction.View,
        item: CompanySettingsPermissions.appraisalSeasonTab,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearch,
      },
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.employeeSearchResults,
      },
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuAttentionPoints,
      },
    ],
  },
  {
    name: RoleName.GlobalAdmin,
    permissions: [
      {
        action: PermissionAction.ViewAlways,
        item: SidebarPermissions.sidemenuGlobalAdmin,
      },
    ],
  },
  {
    name: RoleName.ChatbotUser,
    permissions: [
      {
        action: PermissionAction.View,
        item: EmployeeListPermissions.chatbotUser,
      },
    ],
  },
  {
    name: RoleName.Downloader,
    permissions: [
      {
        action: PermissionAction.View,
        item: SidebarPermissions.sidemenuDownloads,
      },
    ],
  },
]
